import { render, staticRenderFns } from "./Textareas.vue?vue&type=template&id=605d1b53"
import script from "./Textareas.vue?vue&type=script&lang=js"
export * from "./Textareas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports